import { render, staticRenderFns } from "./dealDashboard.vue?vue&type=template&id=3f1b6966&scoped=true"
import script from "./dealDashboard.vue?vue&type=script&lang=js"
export * from "./dealDashboard.vue?vue&type=script&lang=js"
import style0 from "./dealDashboard.vue?vue&type=style&index=0&id=3f1b6966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b6966",
  null
  
)

export default component.exports